// client/src/pages/doctors/FormEditor.jsx
import React from 'react';
import FormEditorComponent from '../../components/doctors/FormBuilder/FormEditor';

const FormEditor = () => {
  return <FormEditorComponent />;
};

export default FormEditor;